export enum BarometerMeasureEnum {
  PERCENTILE_80 = 'PERCENTILE_80',
  PERCENTILE_95 = 'PERCENTILE_95',
  AVERAGE = 'AVERAGE',
  TERRITORY = 'TERRITORY',
  POPULATION = 'POPULATION',
  PERCENTAGE_120S = 'PERCENTAGE_120S',
}
